import {
  QueueHealthStatus,
  SchedulerHealthStatus,
  SchedulerStatusResponse,
} from "../../../services";
import { Tone } from "../styles";

const STATUS_TONES: Record<SchedulerHealthStatus, Tone> = {
  healthy: "healthy",
  warning: "warning",
  critical: "critical",
  unknown: "unknown",
};

const STATUS_LABELS: Record<SchedulerHealthStatus, string> = {
  healthy: "Healthy",
  warning: "Warning",
  critical: "Critical",
  unknown: "Not yet observed",
};

export const toneOfStatus = (
  status: QueueHealthStatus | SchedulerHealthStatus,
) => STATUS_TONES[status];

export const labelOfStatus = (
  status: QueueHealthStatus | SchedulerHealthStatus,
) => STATUS_LABELS[status];

const SCHEDULER_RANK: Record<SchedulerHealthStatus, number> = {
  critical: 0,
  warning: 1,
  unknown: 2,
  healthy: 3,
};

export const problemsFirst = (
  schedulers: SchedulerStatusResponse[],
): SchedulerStatusResponse[] =>
  [...schedulers].sort(
    (a, b) => SCHEDULER_RANK[a.status] - SCHEDULER_RANK[b.status],
  );
